var map = {
	"./customer-detail/reducer/index.js": 25532,
	"./customer-list/reducer/index.js": 48937,
	"./goods-detail/reducer/index.js": 58376,
	"./goods-list/reducer/index.js": 42981,
	"./login/reducer/index.js": 18115,
	"./order-detail/reducer/index.js": 10498,
	"./order-list/reducer/index.js": 68651,
	"./order-refund-detail/reducer/index.js": 96823,
	"./order-refund-list/reducer/index.js": 75618,
	"./robot-goods-detail/reducer/index.js": 60643,
	"./robot-goods/reducer/index.js": 31589,
	"./robot-lcheck/reducer/index.js": 60483,
	"./robot-qa-basic/reducer/index.js": 15270,
	"./robot-qa-high-frequency/reducer/index.js": 94421,
	"./robot-qa-size/reducer/index.js": 71399,
	"./robot-qdata/reducer/index.js": 38828,
	"./servicio-message/reducer/index.js": 79070,
	"./servicio-setting/reducer/index.js": 25169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12277;